import React from 'react';
import { boldSubstr } from '../../../../Components/QuickSearchResult';
import { translate } from '../../../../Services/translation';
import { NavLink } from 'react-router-dom';

const CustomerSearchResult = (props) => {

    return <div className="quick-search-result">
         {props.result && props.result.length > 0 ? (
                props.result.map((item, index) => (
                    <div key={`panel-${item.name}-${index}`} className={`tabs-panel is-active`} id={item.name}>
                        <div className="product-row">
                            <div>
                                <div className="name" dangerouslySetInnerHTML={{ __html: boldSubstr(item.name, props.query) }}></div>
                                <div className="email" dangerouslySetInnerHTML={{ __html: boldSubstr(item.email, props.query) }}></div>
                                <div className="phone" dangerouslySetInnerHTML={{ __html: boldSubstr(item.phone, props.query) }}></div>
                            </div>
                            <div className="button">
                                <NavLink to={"/customerdetails?Id=" + item.systemId}>{translate("coptikk.adminportal.customer.seecustomerdetails")}</NavLink>
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <div className="no-results-message">{translate("coptikk.adminportal.customer.search.nohits")}</div>
            )}
        <i className="close" onClick={props.onClose}></i>
    </div>
}

export default CustomerSearchResult;